module.exports = __webpack_public_path__ + "static/Thai Association Fintech Logo.ec003441.png";